"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockBassUArticle = exports.mockOmniaPrismicArticle = void 0;
const test_helpers_1 = require("../test_helpers");
function mockOmniaPrismicArticle(overrides = {}) {
    return {
        hero: null,
        published_at: 'string',
        source: 'omnia',
        thumbnail: null,
        title: 'mock_title',
        uid: `uid_${(0, test_helpers_1.incrementingId)()}`,
        tags: [],
        youtube_url: null,
        ...overrides,
    };
}
exports.mockOmniaPrismicArticle = mockOmniaPrismicArticle;
function mockBassUArticle(overrides = {}) {
    return {
        hero: null,
        published_at: 'string',
        source: 'bass_utopia',
        thumbnail: null,
        title: 'mock_title',
        uid: `uid_${(0, test_helpers_1.incrementingId)()}`,
        tags: [],
        youtube_url: 'https://www.youtube.com/watch?v=fyNhGZzP3DY',
        ...overrides,
    };
}
exports.mockBassUArticle = mockBassUArticle;
